var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileAppSupportMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5aca48;}.cls-2{fill:#fdfeff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web_Application_Support_Maintenance",
    "data-name": "Web Application Support & Maintenance"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,10A10,10,0,0,1,10,0H40A10,10,0,0,1,50,10V40A10,10,0,0,1,40,50H10A10,10,0,0,1,0,40Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.16,9c.5.1,1,.2,1.4.3a6.58,6.58,0,0,1,4.3,8.1.66.66,0,0,0,.1.6l9.9,9.9a.62.62,0,0,0,.7.2,7.72,7.72,0,0,1,3.7,0,6.39,6.39,0,0,1,4.5,5,7.08,7.08,0,0,1,0,2.9.94.94,0,0,1-1.1.8.86.86,0,0,1-.6-.3l-2.4-2.4A1.9,1.9,0,0,0,34,34c-.1.1-.1.2-.2.2a2,2,0,0,0,0,2.3,17,17,0,0,0,1.9,1.9l.8.8a.93.93,0,0,1,.1,1.3.55.55,0,0,1-.5.3,6.49,6.49,0,0,1-7.9-4.6c0-.1-.1-.2-.1-.4a8.1,8.1,0,0,1,.1-3.1A.62.62,0,0,0,28,32l-9.9-9.9a.66.66,0,0,0-.7-.2,6.82,6.82,0,0,1-4-.1,6.51,6.51,0,0,1-4.2-5c0-.3-.1-.6-.1-.9v-.6c.1-.4.1-.9.2-1.3a1,1,0,0,1,1.1-.8.55.55,0,0,1,.5.3l.7.7,1.9,1.9a2,2,0,0,0,2.3,0,1.9,1.9,0,0,0,.4-2.6c-.1-.1-.1-.2-.2-.3L13.56,11a1,1,0,0,1-.1-1.4.86.86,0,0,1,.6-.3l1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.06,36.8a4.84,4.84,0,0,1,.7-1.8c.1-.2.3-.3.4-.5l8.7-8.8.1-.1,5.3,5.3-.1.1-8.7,8.7a3.71,3.71,0,0,1-5,.4,3.34,3.34,0,0,1-1.4-2.3c0-.1,0-.2-.1-.2l.1-.8Zm5,.5c.2,0,.4-.2.6-.4l5.4-5.5.2-.2a1,1,0,0,0-.2-1.3.76.76,0,0,0-.4-.2,1,1,0,0,0-1,.4l-5.4,5.4c-.1.1-.2.2-.2.3a1.18,1.18,0,0,0-.1,1A1.61,1.61,0,0,0,14.06,37.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.66,9a4.23,4.23,0,0,1,.7.5l1.3,1.3a1.08,1.08,0,0,1,.2,1.4c-.9,1.6-1.9,3.1-2.8,4.7a1,1,0,0,1-1.4.4c-.1-.1-.2-.1-.3-.2a1,1,0,0,1-.4-.5l-6.3,6.3-2.6-2.6,6.2-6.3-.4-.4a1.05,1.05,0,0,1,0-1.3c.1-.1.1-.1.2-.1,1.7-1,3.3-2,5-3a.37.37,0,0,1,.3-.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileAppSupportMaintenance);
export default __webpack_public_path__ + "static/media/Mobile-App-Support-_-Maintenance.5cc810fb0ae68390c592b0b85ccc23a4.svg";
export { ForwardRef as ReactComponent };